import { useGlobalConfigsStore } from "@/storeModules/globalConfigs/globalConfigs";
import { useUserConfigStore } from "@/storeModules/userConfigs";
import { useTranslation } from "i18next-vue";

export function useLanguageChanger() {
  const { i18next } = useTranslation();
  const globalStore = useGlobalConfigsStore();
  const userStore = useUserConfigStore();

  async function changeLanguage(lang: string) {
    // check if the lang we are trying to change to exists.
    // if not, do nothing
    if (!globalStore.availableLanguages[lang]) {
      return;
    }
    // first send request to backend and wait for confirmation
    if (globalStore.isAuth && globalStore.connector) {
      // await the call so we can be sure, future API calls have the correct language set in BE
      await globalStore.connector.general.setLanguage({
        language: lang.toUpperCase(),
      });
      // i18n returns the lang in lowercase. BE needs it in uppercase.
      userStore.userSettings.language = lang.toUpperCase();
    }
    // then change the settings in app.
    i18next.changeLanguage(lang);
    localStorage.setItem("prominent.user.language", lang);
    globalStore.setLanguage(lang);
  }

  return {
    changeLanguage,
  };
}
